module.exports = __webpack_public_path__ + "static/media/district7.41995508.pdf";